<template>
  <el-table-column :label="label" :prop="prop" class-name="flight-purpose-code" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '飛行目的'
    },
    prop: {
      type: String,
      default: 'flight_purpose_code'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.flight-purpose-code {
      width: 8em;
    }
  }
}
</style>
